import { useState, useEffect } from 'react';

export default function DevDisclaimerPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay so page has time to paint first
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="bg-zinc-950 border border-zinc-700 max-w-lg w-full p-8 shadow-2xl relative">
        {/* Accent bar */}
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-white" />

        {/* Icon */}
        <div className="flex items-center gap-3 mb-5">
          <div className="w-11 h-11 bg-white flex items-center justify-center flex-shrink-0">
            <i className="ri-tools-line text-black text-xl"></i>
          </div>
          <div>
            <div className="text-white text-lg font-bold tracking-tight">Website u razvoju</div>
            <div className="text-gray-500 text-xs uppercase tracking-widest font-semibold">Site under development</div>
          </div>
        </div>

        <p className="text-gray-300 text-sm leading-relaxed mb-6">
          Ova web stranica je trenutno u razvoju. Za sve upite i kupovine molimo vas kontaktirajte nas direktno putem Instagrama, telefona ili WhatsAppa.
        </p>

        {/* Contact options */}
        <div className="flex flex-col gap-3 mb-7">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/budzevina/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-zinc-900 border border-zinc-800 px-5 py-4 hover:border-white hover:bg-zinc-800 transition-all group"
          >
            <i className="ri-instagram-line text-white text-xl flex-shrink-0"></i>
            <div>
              <div className="text-white text-sm font-semibold group-hover:text-white">Instagram</div>
              <div className="text-gray-400 text-xs">@budzevina</div>
            </div>
            <i className="ri-arrow-right-line text-gray-600 group-hover:text-white ml-auto transition-colors"></i>
          </a>

          {/* Phone */}
          <a
            href="tel:+381642428074"
            className="flex items-center gap-4 bg-zinc-900 border border-zinc-800 px-5 py-4 hover:border-white hover:bg-zinc-800 transition-all group"
          >
            <i className="ri-phone-line text-white text-xl flex-shrink-0"></i>
            <div>
              <div className="text-white text-sm font-semibold">Telefon</div>
              <div className="text-gray-400 text-xs">+381 64 242 8074</div>
            </div>
            <i className="ri-arrow-right-line text-gray-600 group-hover:text-white ml-auto transition-colors"></i>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/381642428074"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-zinc-900 border border-zinc-800 px-5 py-4 hover:border-white hover:bg-zinc-800 transition-all group"
          >
            <i className="ri-whatsapp-line text-white text-xl flex-shrink-0"></i>
            <div>
              <div className="text-white text-sm font-semibold">WhatsApp</div>
              <div className="text-gray-400 text-xs">+381 64 242 8074</div>
            </div>
            <i className="ri-arrow-right-line text-gray-600 group-hover:text-white ml-auto transition-colors"></i>
          </a>
        </div>

        <button
          onClick={() => setVisible(false)}
          className="w-full bg-white text-black text-sm font-bold py-3 px-6 hover:bg-gray-200 transition-all tracking-wide"
        >
          RAZUMEM / UNDERSTOOD
        </button>
      </div>
    </div>
  );
}
